module.exports = __webpack_public_path__ + "static/media/MoreIcon.98acaefe.svg";